import { useState } from 'react';
import axios from '../axios/axiosConfig';
import { useDispatch } from 'react-redux';
import { enqueueApiCall } from '../redux/slices/apiQueueSlice';

const useHandleGlobalSearch = (selectedApiUrls) => {
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
  
    const handleSearch = async () => {
      setLoading(true);
      try {
        const validApiUrls = Object.values(selectedApiUrls).filter(url => url);
        if (validApiUrls.length === 0) {
          throw new Error("No valid API URLs provided");
        }

        const allResults = [];
        let generalProjectData = [];
  
        // Fetch generalProject first
        await dispatch(
          enqueueApiCall(async () => {
            const response = await axios.get(selectedApiUrls.generalProject);
            generalProjectData = response.data || [];
          })
        );
  
        // Loop through each selected API URL and make calls
        for (const [key, apiUrl] of Object.entries(selectedApiUrls)) {
          if (key === 'generalProject') continue; // Skip if it's already fetched

          const currentGeneralProjectData = [...generalProjectData]; // Create a copy of generalProjectData
  
          dispatch(
                enqueueApiCall(async () => {
                    const response = await axios.get(apiUrl);
                    const responseData = response.data || [];
                  
                    // Enrich each result with JobNumber and ProjectName if ID matches in currentGeneralProjectData
                    const enrichedData = responseData.map((item) => {
                        const projectInfo = currentGeneralProjectData.find(
                            (project) => item.ProjectID === project.ID // Match projectId with ID in generalProject
                        );
                        return {
                            ...item,
                            ProjectID: projectInfo?.ID,
                            JobNumber: projectInfo?.JobNumber,
                            ProjectName: projectInfo?.ProjectName,
                            ModelNumber: projectInfo?.ModelNumber,
                            State: projectInfo?.State,
                            SalesQuoteID: projectInfo?.SalesQuoteID,
                            SalesRep: projectInfo?.SalesRep,
                            ProjectManager: projectInfo?.ProjectManager,
                        };
                    });

                    allResults.push(
                        ...enrichedData.map((item) => ({ ...item, source: key }))
                    );
                })
            );
        }
  
        setResults(allResults);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };
  
    return { handleSearch, results, loading };
  };
  
  export default useHandleGlobalSearch;
